import { RemoveCircle } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import log from 'loglevel';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import { ThumbsDown } from '../../../../icons/thumbs-down';
import { ThumbsUp } from '../../../../icons/thumbs-up';
import { ACTION_MENU_TYPE } from '../consts';
import { useAuth } from '../../../../hooks/useAuth';
import STRING_KEYS from '../../../../language/keys';
import { PERMISSIONS } from '../../../../consts/permissions';
import { MatchStatusEnum } from '../../../../consts/enums';
import { CandidateMatchesBulkPanelItems } from './CandidateMatchesBulkPanelItems';
import { style } from './style';

type CandidateMatchesBulkPanelProps = {
  counter: number,
  onResetSelectedIds: () => void,
  onRejectClick: () => void,
  onAcceptClick: (status: MatchStatusEnum) => void,
}

const TAG = '[CANDIDATE_MATCH_BULK_EDIT]';

export const CandidateMatchesBulkPanel = ({
  counter,
  onResetSelectedIds,
  onRejectClick,
  onAcceptClick,
}: CandidateMatchesBulkPanelProps):JSX.Element => {
  const rejectAnchorRef = useRef<HTMLLIElement>(null);
  const { t: translate } = useTranslation();
  const { hasPermissions } = useAuth();
  const defaultActions = [
    {
      title: STRING_KEYS.REJECT,
      icon: <ThumbsDown />,
      type: ACTION_MENU_TYPE.REJECT,
      permissions: [PERMISSIONS.MATCH_CANDIDATE_REJECT],
      color: '#D14343',
      ref: rejectAnchorRef,
    },
    {
      title: STRING_KEYS.DRAFT,
      icon: <ThumbsUp />,
      type: ACTION_MENU_TYPE.ACCEPT_DRAFT,
      permissions: [PERMISSIONS.MATCH_CANDIDATE_PROMOTE],
      color: '#ffbf4c',
    },
    {
      title: STRING_KEYS.PUBLISH,
      icon: <ThumbsUp />,
      type: ACTION_MENU_TYPE.ACCEPT_PUBLISHED,
      permissions: [PERMISSIONS.MATCH_CANDIDATE_PROMOTE],
      color: '#14B8A6',
    },
  ];

  const actions = defaultActions.filter((action) => {
    return !action.permissions || hasPermissions(action.permissions);
  }).map((defaultAction) => {
    const title = translate(defaultAction.title);

    return {
      icon: defaultAction.icon,
      title,
      type: defaultAction.type,
      color: defaultAction.color,
      ref: defaultAction.ref,
    };
  });

  const handlersActionMenu = (type:string) => {
    switch (type) {
      case ACTION_MENU_TYPE.REJECT:
        onRejectClick();
        break;
      case ACTION_MENU_TYPE.ACCEPT_PUBLISHED:
        onAcceptClick(MatchStatusEnum.published);
        break;
      case ACTION_MENU_TYPE.ACCEPT_DRAFT:
        onAcceptClick(MatchStatusEnum.draft);
        break;
      default: {
        log.warn(TAG, 'No such type of action');
      }
    }
  };

  return (
    <Box sx={ style.box.sx }>
      <Box sx={ style.row.sx }>
        <Box sx={ style.flex.sx }>
          <IconButton onClick={ onResetSelectedIds }>
            <RemoveCircle />
          </IconButton>
          <Typography variant="body2" sx={ style.Typography.sx }>
            {counter}
            &nbsp;
            {counter === 1 ?
              translate(STRING_KEYS.MATCH_SELECTED) :
              translate(STRING_KEYS.MATCHES_SELECTED)}
          </Typography>
        </Box>
        <CandidateMatchesBulkPanelItems
          items={ actions }
          onActionClick={ handlersActionMenu }
        />
      </Box>
    </Box>
  );
};
